import React, { useEffect } from "react";
import { Container, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { getOverview } from "../../redux/evaluacion_desempenio/Overview/actions";
import LinkDescargaGD from "../gestorDocumental/LinkDescargaGD";
import config from "../../config";
import { Radar } from "react-chartjs-2";

const ResumenColaboradorCompleto = (props) => {
  const dispatch = useDispatch();

  const { email } = config.gestorDocumental;
  const { loading, overviews } = useSelector((store) => store.overview);

  // Métodos
  const _getOverview = () => {
    dispatch(
      getOverview({
        id: parseInt(props.idEvaluacion),
      })
    );
  };
  useEffect(() => {
    _getOverview();
  }, []);

  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return "Primer";
      case 2:
        return "Segundo";
      case 3:
        return "Tercero";
      case 4:
        return "Cuarto";
      case 5:
        return "Quinto";
      case 6:
        return "Sexto";
      default:
        return "Septimo";
    }
  };

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "-99999999999px",
        }}
      >
        <Container fluid>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <div id="captureAll">
                <div id="capture">
                  <div id="capture1">
                    <div id="codigoId1">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <div id="codigoId3">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Evaluación por COMPETENCIA y por FACTOR
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Row className="d-flex flex-wrap justify-content-sm-end align-items-center">
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Empresa:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].empresa
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Fecha actual:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={moment().format("DD/MM/YYYY")}
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Tipo de evaluación:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0]
                                        .tipo_evaluacion
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="12" className="mt-2">
                      <Row className="d-flex flex-wrap justify-content-sm-end align-items-center">
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Fecha de evaluación:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data[0].fecha_evaluacion
                                    ? moment(
                                        overviews.informacion.data[0]
                                          .fecha_evaluacion
                                      ).format("DD/MM/YYYY")
                                    : "No realizada"
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Periodo:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? `${renderSwitch(
                                        overviews.informacion.data[0].periodo
                                      )} Periodo`
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Frequencia:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].frecuencia
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 pt-3 pb-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Row className="justify-content-sm-end align-items-center flex-nowrap">
                        <Col>
                          <h6 className="font-weight-bold text-uppercase">
                            Datos del evaluado
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <Col md="12" className="mt-3">
                      <Row className="mb-2 d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Nombre:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].nombre
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Función:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].funcion
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Departamento:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].departamento
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <div className="mt-3 mb-1 pl-md-4 pr-md-3 pl-2 pr-1 pt-3 pb-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Row className="justify-content-sm-end align-items-center flex-nowrap">
                        <Col>
                          <h6 className="font-weight-bold text-uppercase">
                            Datos del evaluador
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    {overviews &&
                      overviews.informacion &&
                      overviews.informacion.data[0].evaluadores.map((item) => (
                        <>
                          <Col md="12" className="mt-3">
                            <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Nombre:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Evaluador}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Función:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Función}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Relación:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Relación}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      ))}
                    <Table responsive size="sm" className="mt-3">
                      <thead className="bg-dark text-light">
                        <tr className="bdrLeft bdrRight">
                          <th className="bdrLeft text-uppercase text-center">
                            Puntuación total
                          </th>
                          <th className="text-uppercase text-center">
                            Desempeño
                          </th>
                          <th className="text-uppercase text-center">
                            Puntuación total por factor
                          </th>
                          <th className="text-uppercase text-center">
                            Desempeño por factor
                          </th>
                          <th className="text-uppercase text-center">
                            Puntuación total por competencia
                          </th>
                          <th className="bdrRight text-uppercase text-center">
                            Desempeño por competencia
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              color:
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .total_desempenio &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) > 60 &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) < 75
                                  ? "orange"
                                  : "unset",
                            }}
                            className={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].total_desempenio &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) < 61
                                ? "text-danger text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 74 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 90
                                ? "text-warning text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 89 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 101
                                ? "text-success text-center text-uppercase"
                                : "text-center text-uppercase"
                            }
                          >
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  } ${
                                    parseInt(
                                      overviews.informacion.data[0]
                                        .total_desempenio
                                    )
                                      ? "%"
                                      : ""
                                  }`
                                : ""}
                            </b>
                          </td>
                          <td
                            style={{
                              color:
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .total_desempenio &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) > 60 &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) < 75
                                  ? "orange"
                                  : "unset",
                            }}
                            className={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].total_desempenio &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) < 61
                                ? "text-danger text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 74 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 90
                                ? "text-warning text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 89 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 101
                                ? "text-success text-center text-uppercase"
                                : "text-center text-uppercase"
                            }
                          >
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0].desempenio
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .nota_total_factor
                                  }
                            ${
                              parseInt(
                                overviews.informacion.data[0].nota_total_factor
                              )
                                ? "%"
                                : ""
                            }`
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0]
                                    .nota_total_factor_desempenio
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .nota_total_competencia
                                  }
                            ${
                              parseInt(
                                overviews.informacion.data[0]
                                  .nota_total_competencia
                              )
                                ? "%"
                                : ""
                            }`
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0]
                                    .nota_total_competencia_desempeno
                                : ""}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <Table responsive size="sm" className="mt-3">
                      <thead className="bg-dark text-light">
                        <tr className="bdrLeft bdrRight">
                          <th className="bdrLeft text-uppercase text-center">
                            Factor
                          </th>
                          {overviews &&
                            overviews.metricas_factor &&
                            overviews.metricas_factor.map((item, index) => (
                              <>
                                <th
                                  className={`${
                                    overviews.metricas_factor.length - 1 ===
                                    index
                                      ? "bdrRight"
                                      : ""
                                  } text-uppercase text-center`}
                                >
                                  {item}
                                </th>
                              </>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {overviews &&
                          overviews.matriz_marcas_factor &&
                          overviews.matriz_marcas_factor.map((item) => (
                            <>
                              <tr>
                                <td
                                  style={{
                                    minWidth: "90px",
                                  }}
                                  className="text-uppercase"
                                >
                                  <b>{item.factor}</b>
                                </td>
                                {item.puntuaciones &&
                                  item.puntuaciones.map((_item) => (
                                    <>
                                      <td className="text-center">{_item}</td>
                                    </>
                                  ))}
                              </tr>
                            </>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  <div id="capture2">
                    <div id="codigoId4">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <Row className="mt-3 mb-1">
                      <Col md="6">
                        <Table responsive size="sm">
                          <thead className="bg-dark text-light">
                            <tr className="bdrLeft bdrRight">
                              <th className="bdrLeft text-uppercase text-center">
                                Competencia
                              </th>
                              <th className="text-uppercase text-center">
                                Puntaje
                              </th>
                              <th className="text-uppercase text-center">
                                Esperado
                              </th>
                              <th className="bdrRight text-uppercase text-center">
                                Semaforo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {overviews &&
                              overviews.matriz_competencia &&
                              overviews.matriz_competencia.map((item) => (
                                <>
                                  <tr>
                                    <td className="text-uppercase">
                                      <b>{item.nombre_competencia}</b>
                                    </td>
                                    <td className="text-center">
                                      {item.puntaje_obtenido}%
                                    </td>
                                    <td className="text-center">
                                      {item.puntaje_esperado}%
                                    </td>
                                    <td>
                                      <Col
                                        className={
                                          item.semaforo === 0
                                            ? "circle-green d-flex flex-wrap justify-content-center align-items-center"
                                            : "circle-red d-flex flex-wrap justify-content-center align-items-center"
                                        }
                                        // className="d-flex flex-wrap justify-content-center align-items-center"
                                      >
                                        {/* <div
                                        className={
                                          item.semaforo === 0
                                            ? "circle-green p-1"
                                            : "circle-red p-1"
                                        }
                                      > */}
                                        {item.puntaje_obtenido -
                                          item.puntaje_esperado}
                                        %{/* </div> */}
                                      </Col>
                                    </td>
                                  </tr>
                                </>
                              ))}
                            {/* <tr>
                        <td>Competencia 1</td>
                        <td>25%</td>
                        <td>95%</td>
                        <td>
                          <div className="circle-red"></div>
                        </td>
                      </tr>
                      <tr>
                        <td>Competencia 2</td>
                        <td>25%</td>
                        <td>95%</td>
                        <td>
                          <div className="circle-green"></div>
                        </td>
                      </tr> */}
                          </tbody>
                        </Table>
                      </Col>
                      <Col md="4" className="mx-auto">
                        {overviews && overviews.dashboard && (
                          <>
                            <Row>
                              {overviews.dashboard.datasets[0] && (
                                <Col xs="auto" className="mx-auto mb-1">
                                  <Row>
                                    <div
                                      style={{
                                        width: "100px",
                                        color:
                                          overviews.dashboard.datasets[0]
                                            .backgroundColor,
                                        backgroundColor:
                                          overviews.dashboard.datasets[0]
                                            .backgroundColor,
                                      }}
                                      className="rounded mr-1"
                                    >
                                      {" "}
                                    </div>
                                    <div className="text-muted mr-2">
                                      <b>
                                        {overviews.dashboard.datasets[0].label}
                                      </b>
                                    </div>
                                  </Row>
                                </Col>
                              )}
                              {overviews.dashboard.datasets[1] && (
                                <Col xs="auto" className="mx-auto mb-1">
                                  <Row>
                                    <div
                                      style={{
                                        width: "100px",
                                        color:
                                          overviews.dashboard.datasets[1]
                                            .backgroundColor,
                                        backgroundColor:
                                          overviews.dashboard.datasets[1]
                                            .backgroundColor,
                                      }}
                                      className="rounded mr-1"
                                    >
                                      {" "}
                                    </div>
                                    <div className="text-muted">
                                      <b>
                                        {overviews.dashboard.datasets[1].label}
                                      </b>
                                    </div>
                                  </Row>
                                </Col>
                              )}
                            </Row>
                            <Radar
                              // height={155}
                              data={overviews.dashboard}
                              options={{
                                fill: false,
                                interaction: {
                                  intersect: false,
                                },
                                responsive: true,
                                plugins: {
                                  legend: {
                                    display: false,
                                  },
                                },
                                //scales: {
                                //  x: { stacked: true },
                                //  y: { stacked: true }
                                // },
                                // radius: 60,
                              }}
                            />
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="px-3 mt-3 mb-5 d-flex flex-wrap justify-content-start align-items-center">
                      <Col md="6" xs="auto">
                        <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Form.Label
                            column
                            md="5"
                            xs="auto"
                            className="text-uppercase"
                          >
                            <b>Tipo de plan de acción:</b>
                          </Form.Label>
                          <Col md="7" xs="auto">
                            <Form.Control
                              className="rounded-pill form-control-sm"
                              type="text"
                              disabled
                              value={
                                overviews.informacion &&
                                overviews.informacion.data[0] &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj[0] &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj[0].descripcion
                                  ? overviews.informacion.data[0]
                                      .tipo_plan_accion_obj[0].descripcion
                                  : "No ingresado"
                              }
                            ></Form.Control>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="6" xs="auto">
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          <Col xs="auto">
                            <label className="mx-3 text-uppercase">
                              <b>Plan de acción:</b>
                            </label>
                          </Col>
                          <Col md="6">
                            {overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0]
                              .archivo_id_documento &&
                            overviews.informacion.data[0].archivo_llave ? (
                              <>
                                <ul className="list-unstyled">
                                  <LinkDescargaGD
                                    id={parseInt(props.idEvaluation)}
                                    filters={{
                                      email: email,
                                      id: overviews.informacion.data[0]
                                        .archivo_id_documento,
                                      llave:
                                        overviews.informacion.data[0]
                                          .archivo_llave,
                                    }}
                                    origen={
                                      overviews.informacion.data[0]
                                        .archivo_origen
                                    }
                                    cType={
                                      overviews.informacion.data[0]
                                        .archivo_contentTypeGD
                                    }
                                  />
                                </ul>
                              </>
                            ) : (
                              <label>No ingresado.</label>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div id="comentEval1">
                      <Col md="12">
                        <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Form.Label className="text-uppercase" column md="12">
                            <b>Comentario evaluador:</b>
                          </Form.Label>
                          <Col md="12">
                            {/* <Form.Control
                              className="rounded form-control-sm"
                              as="textarea"
                              disabled
                              value={
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .comentario_evaluador
                                  ? overviews.informacion.data[0]
                                      .comentario_evaluador
                                  : ""
                              }
                            ></Form.Control> */}
                            <div
                              className="px-2 py-1 rounded border border-muted"
                              style={{
                                backgroundColor: "#F4F4F4",
                                minHeight: "100px",
                              }}
                            >
                              {overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].comentario_evaluador
                                ? overviews.informacion.data[0]
                                    .comentario_evaluador
                                : ""}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  </div>
                </div>
                <div id="comentarioId">
                  <div id="codigoId2">
                    <Row className="mb-5 d-flex flex-wrap justify-content-end align-items-center">
                      <Col xs="auto">
                        <p className="text-black-50 mx-3">
                          <b>F-896</b>
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div id="comentEval2">
                    <Col md="12">
                      <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Form.Label className="text-uppercase" column md="12">
                          <b>Comentario evaluador:</b>
                        </Form.Label>
                        <Col md="12">
                          {/* <Form.Control
                            className="rounded form-control-sm"
                            as="textarea"
                            disabled
                            value={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].comentario_evaluador
                                ? overviews.informacion.data[0]
                                    .comentario_evaluador
                                : ""
                            }
                          ></Form.Control> */}
                          <div
                            className="px-2 py-1 rounded border border-muted"
                            style={{
                              backgroundColor: "#F4F4F4",
                              minHeight: "100px",
                            }}
                          >
                            {overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0].comentario_evaluador
                              ? overviews.informacion.data[0]
                                  .comentario_evaluador
                              : ""}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                  <Col md="12" className="mt-3 mb-3">
                    <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Form.Label className="text-uppercase" column md="12">
                        <b>Comentario evaluado:</b>
                      </Form.Label>
                      <Col md="12">
                        {/* <Form.Control
                          className="rounded form-control-sm"
                          as="textarea"
                          disabled
                          value={
                            overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0].comentario_evaluado
                              ? overviews.informacion.data[0]
                                  .comentario_evaluado
                              : ""
                          }
                        ></Form.Control> */}
                        <div
                          className="px-2 py-1 rounded border border-muted"
                          style={{
                            backgroundColor: "#F4F4F4",
                            minHeight: "100px",
                          }}
                        >
                          {overviews.informacion &&
                          overviews.informacion.data &&
                          overviews.informacion.data[0].comentario_evaluado
                            ? overviews.informacion.data[0].comentario_evaluado
                            : ""}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="12">
                    <Row className="mt-5 mb-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Col md="4" xs="auto" className="mx-auto my-5">
                        <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <div className="px-2 d-flex flex-wrap justify-content-center align-items-center">
                              <p className="text-uppercase">
                                <b>
                                  {overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0].evaluadores
                                    ? overviews.informacion.data[0]
                                        .tipo_evaluacion === "0°"
                                      ? overviews.informacion.data[0]
                                          .jefe_evaluado_nombre
                                      : overviews.informacion.data[0]
                                          .evaluadores[0]
                                      ? overviews.informacion.data[0]
                                          .evaluadores[0].Evaluador
                                      : "No hay evaluador"
                                    : null}
                                </b>
                              </p>
                            </div>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              {/* <Col
                                className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews &&
                                    overviews.informacion &&
                                    overviews.informacion.data &&
                                    overviews.informacion.data[0].evaluadores
                                      ? overviews.informacion.data[0]
                                          .tipo_evaluacion === "0°"
                                        ? overviews.informacion.data[0]
                                            .jefe_evaluado_nombre
                                        : overviews.informacion.data[0]
                                            .evaluadores[0].Evaluador
                                      : null}
                                  </b>
                                </p>
                              </Col> */}
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews && overviews.informacion
                                      ? overviews.informacion.data[0]
                                          .tipo_evaluacion === "0°"
                                        ? "Firma jefe inmediato"
                                        : "Firma evaluador"
                                      : "Firma evaluador"}
                                  </b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4" xs="auto" className="mx-auto my-5">
                        <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <div className="px-2 d-flex flex-wrap justify-content-center align-items-center">
                              <p className="text-uppercase">
                                <b>
                                  {overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data
                                    ? overviews.informacion.data[0].nombre
                                    : null}
                                </b>
                              </p>
                            </div>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              {/* <Col
                                className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews &&
                                    overviews.informacion &&
                                    overviews.informacion.data
                                      ? overviews.informacion.data[0].nombre
                                      : null}
                                  </b>
                                </p>
                              </Col> */}
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>Firma evaluado</b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default ResumenColaboradorCompleto;
